import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";
import { useProCliStore } from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/ProviderListv2/hooks/useProCliStore.js";

import Template from "./template.jsx";

export default class MedicalRecordsCasesDetailProvidersRoute extends BaseRoute {
  @service("repositories/case-repository") caseRepository;
  @service("repositories/provider-client-status-repository")
  providerClientStatusRepository;
  element = (<Template />);

  async loader({ params }) {
    const { id } = params;
    const limit = useProCliStore.getState().limit;
    const orderingVal = useProCliStore.getState().orderingVal;
    const providerClientObj = await this.providerClientStatusRepository.query({
      case: id,
      limit: limit,
      ordering: orderingVal,
    });
    const providerClientRecCount = await this.providerClientStatusRepository.getTotalCount();
    return { providerClientObj, providerClientRecCount };
  }
}
